import { get, omit } from 'lodash';

import EditIcon from '@mui/icons-material/Edit';
import Icon from '@mui/material/Icon';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const StyledTextField = styled(({ ...other }) => (
  <TextField {...omit(other, 'backgroundField')} />
))(({ theme, backgroundField }) => ({
  fontSize: 14,
  '& .MuiInputBase-root': {
    background: backgroundField
      ? theme?.palette?.booking?.backgroundField
      : theme?.palette?.common?.white,
  },
  '& .MuiIcon-root': { color: theme.palette.primary.light },
}));

const TextInput = ({
  icon = <EditIcon />,
  isIcon = false,
  size = 'small',
  variant = 'outlined',
  required,
  type = 'text',
  maxLength = null,
  backgroundField = true,
  touched = {},
  errors = {},
  name,
  value,
  ...rest
}) => {
  return (
    <StyledTextField
      autoComplete='off'
      size={size}
      name={name}
      value={value}
      type={type}
      variant={variant}
      backgroundField={backgroundField}
      error={Boolean(get(touched, name) && get(errors, name))}
      helperText={get(touched, name) && get(errors, name)}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: icon ? (
          <InputAdornment position='end'>
            {isIcon && <Icon>{icon}</Icon>}
          </InputAdornment>
        ) : null,
      }}
      {...rest}
      required={required}
      FormHelperTextProps={{ ['data-test-id']: name }}
    />
  );
};

export default TextInput;
